"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

var _grid = _interopRequireDefault(require("./grid/grid.component"));

var _gridCheck = _interopRequireDefault(require("./helper-functions/gridCheck"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Grids = function Grids(_ref) {
  var moveAllLinesMode = _ref.moveAllLinesMode,
      allowPlaceGrid = _ref.allowPlaceGrid,
      gridWarnings = _ref.gridWarnings,
      width = _ref.width,
      height = _ref.height,
      onPlaceAllGrids = _ref.onPlaceAllGrids,
      onPlaceGrid = _ref.onPlaceGrid,
      onPlaceVLine = _ref.onPlaceVLine,
      onPlaceHLine = _ref.onPlaceHLine,
      onPlaceVLineExt = _ref.onPlaceVLineExt,
      onPlaceHLineExt = _ref.onPlaceHLineExt,
      onDeleteVLine = _ref.onDeleteVLine,
      onDeleteHLine = _ref.onDeleteHLine,
      onDeleteRect = _ref.onDeleteRect,
      onFinishMoveRect = _ref.onFinishMoveRect,
      onFinishTransformRect = _ref.onFinishTransformRect,
      onFinishMoveVLine = _ref.onFinishMoveVLine,
      onFinishMoveHLine = _ref.onFinishMoveHLine,
      onClearRectLines = _ref.onClearRectLines,
      updateDeleteLineFunction = _ref.updateDeleteLineFunction,
      updateDeleteRectFunction = _ref.updateDeleteRectFunction,
      updateClearRectFunction = _ref.updateClearRectFunction,
      onSelectObject = _ref.onSelectObject,
      setAddColRowFunction = _ref.setAddColRowFunction,
      setClearCurrentSelectionFunction = _ref.setClearCurrentSelectionFunction,
      setPopulateGrids = _ref.setPopulateGrids,
      setExternalGrids = _ref.setExternalGrids,
      tooltipClickAction = _ref.tooltipClickAction,
      isSideNavBarInfoOpen = _ref.isSideNavBarInfoOpen,
      setClearAllRectsLines = _ref.setClearAllRectsLines,
      setAddAutoMergeRowsColumns = _ref.setAddAutoMergeRowsColumns;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      grids = _useState2[0],
      setGrids = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      gridsFixed = _useState4[0],
      setGridsFixed = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      rectSelectedId = _useState6[0],
      setRectSelectedId = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      lineSelectedId = _useState8[0],
      setLineSelectedId = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      rectIndex = _useState10[0],
      setRectIndex = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = _slicedToArray(_useState11, 2),
      columnIndex = _useState12[0],
      setColumnIndex = _useState12[1];

  var _useState13 = (0, _react.useState)(0),
      _useState14 = _slicedToArray(_useState13, 2),
      rowIndex = _useState14[0],
      setRowIndex = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      clearFunctionRan = _useState16[0],
      setClearFunctionRan = _useState16[1];

  var _useState17 = (0, _react.useState)({
    objectType: null,
    objectId: null
  }),
      _useState18 = _slicedToArray(_useState17, 2),
      selectedObject = _useState18[0],
      setSelectedObject = _useState18[1];

  (0, _react.useEffect)(function () {
    setExternalGrids(gridsFixed);
  }, [setExternalGrids, gridsFixed]);
  /**
   * Checks if a change has occurred. If so let outside component know
   * This is acting as a controlled useEffect
   */

  var selectedObjectChangeCheck = (0, _react.useCallback)(function (newSelectedObject) {
    if (selectedObject["objectId"] !== newSelectedObject["objectId"]) {
      onSelectObject(newSelectedObject);
    }
  }, [selectedObject, onSelectObject]);
  (0, _react.useEffect)(function () {
    var clearSelect = function clearSelect() {
      setRectSelectedId(null);
      setLineSelectedId(null);
      setSelectedObject({
        objectType: null,
        objectId: null
      });
    };

    if (!clearFunctionRan) {
      setClearFunctionRan(true);
      setClearCurrentSelectionFunction(function () {
        return clearSelect;
      });
    }
  }, [setClearCurrentSelectionFunction, clearFunctionRan]);
  var startUpFunction = (0, _react.useCallback)(function (allGrids) {
    var cleanedGrids = (0, _gridCheck.default)(allGrids);
    setGrids(cleanedGrids);
    setGridsFixed(cleanedGrids);
    onPlaceAllGrids(cleanedGrids);
    setRectIndex(allGrids.length - 1);
    setColumnIndex(0);
    setRowIndex(0);
    setRectSelectedId(null);
    setLineSelectedId(null);
    setSelectedObject({
      objectType: null,
      objectId: null
    });
    selectedObjectChangeCheck({
      objectType: null,
      objectId: null
    });
  }, [onPlaceAllGrids, selectedObjectChangeCheck]);
  (0, _react.useEffect)(function () {
    setPopulateGrids(function () {
      return startUpFunction;
    });
  }, [startUpFunction, setPopulateGrids]);
  (0, _react.useEffect)(function () {
    var deleteLine = function deleteLine() {
      if (lineSelectedId !== null) {
        var newGrids = JSON.parse(JSON.stringify(gridsFixed));

        if (lineSelectedId.includes("vLine")) {
          // Find location of deleted Line
          var gridWithVLine;
          var deletedVLine;

          var _iterator = _createForOfIteratorHelper(newGrids),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var grid = _step.value;

              var _iterator2 = _createForOfIteratorHelper(grid.vLines),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var vLine = _step2.value;

                  if (vLine["id"] === lineSelectedId) {
                    gridWithVLine = grid;
                    deletedVLine = vLine;
                    break;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var columnLocation = gridWithVLine.vLines.filter(function (vLine) {
            return vLine["xRectDist"] < deletedVLine["xRectDist"];
          }).length;
          newGrids.forEach(function (grid, index) {
            newGrids[index].vLines = grid.vLines.filter(function (vLine) {
              return vLine.id !== lineSelectedId;
            });
          });
          newGrids.forEach(function (grid, index) {
            newGrids[index].vLines = grid.vLines.filter(function (vLine) {
              return vLine.id !== lineSelectedId;
            });
          });
          setGrids(newGrids);
          setGridsFixed(newGrids);
          onDeleteVLine(newGrids, {
            columnLocation: columnLocation,
            id: lineSelectedId
          });
        }

        if (lineSelectedId.includes("hLine")) {
          newGrids.forEach(function (grid, index) {
            newGrids[index].hLines = grid.hLines.filter(function (hLine) {
              return hLine.id !== lineSelectedId;
            });
          });
          setGrids(newGrids);
          setGridsFixed(newGrids);
          onDeleteHLine(newGrids, "hello");
        }

        setLineSelectedId(null);
        setSelectedObject({
          objectType: null,
          objectId: null
        });
        selectedObjectChangeCheck({
          objectType: null,
          objectId: null
        });
      }
    };

    var deleteRect = function deleteRect() {
      if (rectSelectedId !== null) {
        var newGrids = JSON.parse(JSON.stringify(gridsFixed)).slice().filter(function (grid) {
          return grid.rect.id !== rectSelectedId;
        });
        setGrids(newGrids);
        setGridsFixed(newGrids);
        onDeleteRect(newGrids);
        setRectSelectedId(null);
        setSelectedObject({
          objectType: null,
          objectId: null
        });
        selectedObjectChangeCheck({
          objectType: null,
          objectId: null
        });
      }
    };

    updateDeleteLineFunction(function () {
      return deleteLine;
    });
    updateDeleteRectFunction(function () {
      return deleteRect;
    });
  }, [gridsFixed, lineSelectedId, rectSelectedId, updateDeleteLineFunction, updateDeleteRectFunction, onDeleteHLine, onDeleteVLine, onDeleteRect, selectedObjectChangeCheck]);
  /**
   * Check if current selection has been clicked away from
   * @param {event} e
   */

  var checkDeselect = function checkDeselect(e) {
    // deselect when clicked on empty area
    var clickedOnEmpty = e.target === e.target.getStage();
    var clickedOnRect = e.target.className === "Rect";
    var clickedOnLine = e.target.className === "Line";

    if (clickedOnEmpty) {
      setRectSelectedId(null);
      setLineSelectedId(null);
      setSelectedObject({
        objectType: null,
        objectId: null
      });
      selectedObjectChangeCheck({
        objectType: null,
        objectId: null
      });

      if (allowPlaceGrid.boolean) {
        addGrid(e);
      }
    } else {
      if (!clickedOnRect) {
        setRectSelectedId(null);
      } else if (!clickedOnLine) {
        setLineSelectedId(null);
      }
    }
  };
  /**
   * Checks what line was selected
   * @param {string} lineId
   */


  var lineClick = function lineClick(lineId) {
    if (lineId === lineSelectedId) {
      setLineSelectedId(null);
      setSelectedObject({
        objectType: null,
        objectId: null
      });
      selectedObjectChangeCheck({
        objectType: null,
        objectId: null
      });
    } else {
      setLineSelectedId(lineId);
      setSelectedObject({
        objectType: "line",
        objectId: lineId
      });
      selectedObjectChangeCheck({
        objectType: "line",
        objectId: lineId
      });
    }
  };
  /**
   * Checks what rectangle was selected
   * @param {string} lineId
   */


  var rectClick = function rectClick(rectId) {
    if (rectId === "reset") {
      setRectSelectedId(null);
      setSelectedObject({
        objectType: null,
        objectId: null
      });
      selectedObjectChangeCheck({
        objectType: null,
        objectId: null
      });
    } else if (rectId === rectSelectedId) {
      setRectSelectedId(null);
      setSelectedObject({
        objectType: null,
        objectId: null
      });
      selectedObjectChangeCheck({
        objectType: null,
        objectId: null
      });
    } else {
      setRectSelectedId(rectId);
      setSelectedObject({
        objectType: "rect",
        objectId: rectId
      });
      selectedObjectChangeCheck({
        objectType: "rect",
        objectId: rectId
      });
    }
  };
  /**
   * Adds a new rectangle on click
   * @param {event} e
   */


  var addGrid = function addGrid(e) {
    var newRectIndex = rectIndex + 1;
    setRectIndex(newRectIndex);
    var newGrids = JSON.parse(JSON.stringify(gridsFixed));
    var newGridObject = {
      rect: {
        x: e.evt.offsetX,
        y: e.evt.offsetY,
        width: 200,
        height: 100,
        id: "rect".concat(newRectIndex)
      },
      vLines: [],
      hLines: [],
      page_number: allowPlaceGrid.pageNumber
    };
    var modGrid = [].concat(_toConsumableArray(newGrids), [newGridObject]);
    onPlaceGrid(modGrid);
    setGrids(modGrid);
    setGridsFixed(modGrid);
  };

  (0, _react.useEffect)(function () {
    var clearLines = function clearLines() {
      if (rectSelectedId !== null) {
        var newGrids = JSON.parse(JSON.stringify(gridsFixed));
        var test = newGrids.find(function (grid) {
          return grid.rect.id === rectSelectedId;
        });
        test["hLines"] = [];
        test["vLines"] = [];
        setGrids(newGrids);
        setGridsFixed(newGrids);
        onClearRectLines(newGrids);
      }
    };

    updateClearRectFunction(function () {
      return clearLines;
    });
  }, [updateClearRectFunction, gridsFixed, rectSelectedId, onClearRectLines]);
  (0, _react.useEffect)(function () {
    var clearAllRectsLines = function clearAllRectsLines() {
      var newGrids = JSON.parse(JSON.stringify(gridsFixed));
      var gridsToReturn = [];

      var _iterator3 = _createForOfIteratorHelper(newGrids),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var grid = _step3.value;
          var gridCopy = JSON.parse(JSON.stringify(grid));
          gridCopy["hLines"] = [];
          gridCopy["vLines"] = [];
          gridsToReturn.push(gridCopy);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      setGrids(gridsToReturn);
      setGridsFixed(gridsToReturn);
      onClearRectLines(newGrids);
    };

    setClearAllRectsLines(function () {
      return clearAllRectsLines;
    });
  }, [setClearAllRectsLines, gridsFixed, onClearRectLines]);
  var autoMergePopulateAllGrids = (0, _react.useCallback)(function (autoMergeObject) {
    if (gridsFixed !== null) {
      var moddedGrids = JSON.parse(JSON.stringify(gridsFixed));

      var _iterator4 = _createForOfIteratorHelper(autoMergeObject),
          _step4;

      try {
        var _loop = function _loop() {
          var element = _step4.value;
          var newGrid = void 0;
          var elementRectId = element.rectId;
          var offsetXList = element.columns;
          var elementPageNumber = element.pageNumber;
          var offsetYList = element.rows;
          var fileteredGrid = moddedGrids.filter(function (grid) {
            return grid.rect.id === elementRectId && grid.page_number === elementPageNumber;
          });
          newGrid = fileteredGrid[0];
          var newVLines = [];
          var newHLines = [];

          if (![[], undefined].includes(newGrid)) {
            if (offsetXList.length > 0) {
              var biggestColIndex = -1;

              var _iterator5 = _createForOfIteratorHelper(newGrid["vLines"]),
                  _step5;

              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var vLine = _step5.value;

                  if (vLine["id"].includes("initrect")) {
                    var vLineIndex = parseInt(vLine["id"].split("initrect")[0].replace("vLine", ""));

                    if (vLineIndex > biggestColIndex) {
                      biggestColIndex = vLineIndex;
                    }
                  } else {
                    var _vLineIndex = parseInt(vLine["id"].split("rect")[0].replace("vLine", ""));

                    if (_vLineIndex > biggestColIndex) {
                      biggestColIndex = _vLineIndex;
                    }
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }

              offsetXList.forEach(function (offsetX, i) {
                if (newGrid["rect"]["x"] <= offsetX && offsetX <= newGrid["rect"]["x"] + newGrid["rect"]["width"]) {
                  newVLines.push({
                    x: offsetX,
                    xRectDist: offsetX - newGrid.rect.x,
                    id: "vLine".concat(biggestColIndex + 1 + i).concat(newGrid.rect.id)
                  });
                } else {
                  console.warn("Vertical line with x position ".concat(offsetX, " is not contained within the rectangle ").concat(newGrid["rect"]["id"], ". Bounds: (").concat(newGrid["rect"]["x"], ",").concat(newGrid["rect"]["x"] + newGrid["rect"]["width"], ")"));
                }
              });
              newGrid.vLines = [].concat(_toConsumableArray(newGrid.vLines), newVLines);
              setColumnIndex(biggestColIndex + newVLines.length);
              onPlaceVLineExt(moddedGrids);
            }

            if (offsetYList.length > 0) {
              var biggestRowIndex = -1;

              var _iterator6 = _createForOfIteratorHelper(newGrid["hLines"]),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var hLine = _step6.value;

                  if (hLine["id"].includes("initrect")) {
                    var _vLineIndex2 = parseInt(hLine["id"].split("initrect")[0].replace("hLine", ""));

                    if (_vLineIndex2 > biggestRowIndex) {
                      biggestRowIndex = _vLineIndex2;
                    }
                  } else {
                    var _vLineIndex3 = parseInt(hLine["id"].split("rect")[0].replace("hLine", ""));

                    if (_vLineIndex3 > biggestRowIndex) {
                      biggestRowIndex = _vLineIndex3;
                    }
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }

              offsetYList.forEach(function (offsetY, i) {
                if (newGrid["rect"]["y"] <= offsetY && offsetY <= newGrid["rect"]["y"] + newGrid["rect"]["height"]) {
                  newHLines.push({
                    y: offsetY,
                    yRectDist: offsetY - newGrid.rect.y,
                    id: "hLine".concat(biggestRowIndex + 1 + i).concat(newGrid.rect.id)
                  });
                } else {
                  console.warn("Horizontal line with y position ".concat(offsetY, " is not contained within the rectangle ").concat(newGrid["rect"]["id"], ". Bounds: (").concat(newGrid["rect"]["y"], ",").concat(newGrid["rect"]["y"] + newGrid["rect"]["height"], ")"));
                }
              });
              newGrid.hLines = [].concat(_toConsumableArray(newGrid.hLines), newHLines);
              setRowIndex(biggestRowIndex + newHLines.length);
              onPlaceHLineExt(moddedGrids);
            }

            if (newVLines.length > 0 || newHLines.length > 0) {
              setGrids(moddedGrids);
              setGridsFixed(moddedGrids);
            }
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, [gridsFixed, onPlaceVLineExt, onPlaceHLineExt]);
  (0, _react.useEffect)(function () {
    setAddAutoMergeRowsColumns(function () {
      return autoMergePopulateAllGrids;
    });
  }, [gridsFixed, setAddColRowFunction, autoMergePopulateAllGrids]);
  /**
   * Adds new column
   * @param {event} e
   */

  var addVHLineExternal = (0, _react.useCallback)(function (offsetXList, offsetYList, rectId) {
    if (gridsFixed !== null) {
      var moddedGrids = JSON.parse(JSON.stringify(gridsFixed));
      var newGrid;

      var _iterator7 = _createForOfIteratorHelper(moddedGrids),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var grid = _step7.value;

          if (grid.rect.id === rectId) {
            newGrid = grid;
            break;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var newVLines = [];
      var newHLines = [];

      if (offsetXList.length > 0) {
        var biggestColIndex = -1;

        var _iterator8 = _createForOfIteratorHelper(newGrid["vLines"]),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var vLine = _step8.value;

            if (vLine["id"].includes("initrect")) {
              var vLineIndex = parseInt(vLine["id"].split("initrect")[0].replace("vLine", ""));

              if (vLineIndex > biggestColIndex) {
                biggestColIndex = vLineIndex;
              }
            } else {
              var _vLineIndex4 = parseInt(vLine["id"].split("rect")[0].replace("vLine", ""));

              if (_vLineIndex4 > biggestColIndex) {
                biggestColIndex = _vLineIndex4;
              }
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        offsetXList.forEach(function (offsetX, i) {
          if (newGrid["rect"]["x"] <= offsetX && offsetX <= newGrid["rect"]["x"] + newGrid["rect"]["width"]) {
            newVLines.push({
              x: offsetX,
              xRectDist: offsetX - newGrid.rect.x,
              id: "vLine".concat(biggestColIndex + 1 + i).concat(newGrid.rect.id)
            });
          } else {
            console.warn("Vertical line with x position ".concat(offsetX, " is not contained within the rectangle ").concat(newGrid["rect"]["id"], ". Bounds: (").concat(newGrid["rect"]["x"], ",").concat(newGrid["rect"]["x"] + newGrid["rect"]["width"], ")"));
          }
        });
        newGrid.vLines = [].concat(_toConsumableArray(newGrid.vLines), newVLines);
        setColumnIndex(biggestColIndex + newVLines.length);
        onPlaceVLineExt(moddedGrids);
      }

      if (offsetYList.length > 0) {
        var biggestRowIndex = -1;

        var _iterator9 = _createForOfIteratorHelper(newGrid["hLines"]),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var hLine = _step9.value;

            if (hLine["id"].includes("initrect")) {
              var _vLineIndex5 = parseInt(hLine["id"].split("initrect")[0].replace("hLine", ""));

              if (_vLineIndex5 > biggestRowIndex) {
                biggestRowIndex = _vLineIndex5;
              }
            } else {
              var _vLineIndex6 = parseInt(hLine["id"].split("rect")[0].replace("hLine", ""));

              if (_vLineIndex6 > biggestRowIndex) {
                biggestRowIndex = _vLineIndex6;
              }
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        offsetYList.forEach(function (offsetY, i) {
          if (newGrid["rect"]["y"] <= offsetY && offsetY <= newGrid["rect"]["y"] + newGrid["rect"]["height"]) {
            newHLines.push({
              y: offsetY,
              yRectDist: offsetY - newGrid.rect.y,
              id: "hLine".concat(biggestRowIndex + 1 + i).concat(newGrid.rect.id)
            });
          } else {
            console.warn("Horizontal line with y position ".concat(offsetY, " is not contained within the rectangle ").concat(newGrid["rect"]["id"], ". Bounds: (").concat(newGrid["rect"]["y"], ",").concat(newGrid["rect"]["y"] + newGrid["rect"]["height"], ")"));
          }
        });
        newGrid.hLines = [].concat(_toConsumableArray(newGrid.hLines), newHLines);
        setRowIndex(biggestRowIndex + newHLines.length);
        onPlaceHLineExt(moddedGrids);
      }

      if (newVLines.length > 0 || newHLines.length > 0) {
        setGrids(moddedGrids);
        setGridsFixed(moddedGrids);
      }
    }
  }, [gridsFixed, onPlaceVLineExt, onPlaceHLineExt]);
  (0, _react.useEffect)(function () {
    setAddColRowFunction(function () {
      return addVHLineExternal;
    });
  }, [gridsFixed, setAddColRowFunction, addVHLineExternal]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "canvas-container",
    "data-testid": "canvas-container"
  }, grids !== null ? /*#__PURE__*/_react.default.createElement(_reactKonva.Stage, {
    width: width,
    height: height,
    onMouseDown: checkDeselect,
    id: "test"
  }, /*#__PURE__*/_react.default.createElement(_reactKonva.Layer, null, grids.map(function (grid, i) {
    return /*#__PURE__*/_react.default.createElement(_grid.default, {
      key: i,
      shapeProps: grid,
      isSelected: grid.rect.id === rectSelectedId,
      warningInfo: gridWarnings.find(function (element) {
        return element["gridId"] === grid.rect.id;
      }),
      lineSelectedId: lineSelectedId,
      columnIndex: columnIndex,
      rowIndex: rowIndex,
      moveAllLinesMode: moveAllLinesMode,
      lineClick: lineClick,
      rectClick: rectClick,
      onChangeRect: function onChangeRect(newAttrs) {
        var newGrids = grids.slice();
        newGrids[i].rect = newAttrs;
        setGrids(newGrids);
      },
      onChangeVLines: function onChangeVLines(newAttrs) {
        var newGrids = grids.slice();
        newGrids[i].vLines = newAttrs;
        setGrids(newGrids);
      },
      onChangeHLines: function onChangeHLines(newAttrs) {
        var newGrids = grids.slice();
        newGrids[i].hLines = newAttrs;
        setGrids(newGrids);
      },
      onChangeRectEnd: function onChangeRectEnd() {
        var newGrids = grids.slice();
        onFinishMoveRect(newGrids);
        setGridsFixed(newGrids);
      },
      onChangeTransformEnd: function onChangeTransformEnd() {
        var newGrids = grids.slice();
        onFinishTransformRect(newGrids);
        setGridsFixed(newGrids);
      },
      onChangeVLinesEnd: function onChangeVLinesEnd(newAttrs) {
        var newGrids = gridsFixed.slice();
        newGrids[i].vLines = newAttrs;
        onFinishMoveVLine(newGrids);
        setGrids(newGrids);
        setGridsFixed(newGrids);
      },
      onChangeHLinesEnd: function onChangeHLinesEnd(newAttrs) {
        var newGrids = gridsFixed.slice();
        newGrids[i].hLines = newAttrs;
        onFinishMoveHLine(newGrids);
        setGrids(newGrids);
        setGridsFixed(newGrids);
      },
      onAddVLines: function onAddVLines(newAttrs, columnLocation) {
        var newGrids = gridsFixed.slice();
        newGrids[i].vLines = newAttrs;
        onPlaceVLine(newGrids, columnLocation);
        setGrids(newGrids);
        setGridsFixed(newGrids);
      },
      onAddHLines: function onAddHLines(newAttrs) {
        var newGrids = gridsFixed.slice();
        newGrids[i].hLines = newAttrs;
        onPlaceHLine(newGrids);
        setGrids(newGrids);
        setGridsFixed(newGrids);
      },
      setColumnIndex: setColumnIndex,
      setRowIndex: setRowIndex,
      tooltipClickAction: tooltipClickAction,
      onSelectObject: onSelectObject,
      isSideNavBarInfoOpen: isSideNavBarInfoOpen
    });
  }))) : null);
};

Grids.defaultProps = {
  moveAllLinesMode: true,
  allowPlaceGrid: {},
  gridWarnings: [],
  onPlaceAllGrids: function onPlaceAllGrids() {},
  onPlaceGrid: function onPlaceGrid() {},
  onPlaceVLine: function onPlaceVLine() {},
  onPlaceHLine: function onPlaceHLine() {},
  onPlaceVLineExt: function onPlaceVLineExt() {},
  onPlaceHLineExt: function onPlaceHLineExt() {},
  onDeleteVLine: function onDeleteVLine() {},
  onDeleteHLine: function onDeleteHLine() {},
  onDeleteRect: function onDeleteRect() {},
  onFinishMoveRect: function onFinishMoveRect() {},
  onFinishTransformRect: function onFinishTransformRect() {},
  onFinishMoveVLine: function onFinishMoveVLine() {},
  onFinishMoveHLine: function onFinishMoveHLine() {},
  onClearRectLines: function onClearRectLines() {},
  updateDeleteLineFunction: function updateDeleteLineFunction() {},
  updateDeleteRectFunction: function updateDeleteRectFunction() {},
  onSelectObject: function onSelectObject() {},
  setAddColRowFunction: function setAddColRowFunction() {},
  setClearCurrentSelectionFunction: function setClearCurrentSelectionFunction() {},
  setPopulateGrids: function setPopulateGrids() {},
  setExternalGrids: function setExternalGrids() {}
};
var _default = Grids;
exports.default = _default;